import React, { useEffect, useRef, useState } from "react";
import { adminReturnPath } from "../../functions/adminReturnPath";
import { useNavigate, useLocation } from "react-router-dom";
//Redux
import { useDispatch } from "react-redux";
import {
  setUserLogged,
  setUserData,
  setAlert,
} from "../../reducers/userConfigSlice";
//Components
import { Input, translateMessage } from "@delibrandev/utils";
import { GoMail } from "react-icons/go";
import { LoginInput } from "./loginInput";
import { RiErrorWarningFill } from "react-icons/ri";
//Assets
//Api
import { logIn, validateLogIn } from "../../api/login";
import { decodeToken } from "../../api/utils";
import {
  readLoginLS,
  removeLoginLS,
  saveLoginLS,
} from "../../functions/rememberedLogin";
import { apiRest } from "../../api/constants";

export const FormLogin = ({ callback }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location=useLocation();
  const [loginFailed, setLoginFailed] = useState(false);
  const [require2FA, setRequire2FA] = useState(false);
  const [loginPending, setLoginPending] = useState(false);
  const [loginError, setLoginError] = useState("");
  const loginInFlight = useRef(false);
  const passwordSaved = readLoginLS(apiRest);

  useEffect(() => {
    const passwordSave = document.getElementById("passwordSave");
    if (passwordSaved) passwordSave.checked = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLogin = async () => {
    if (loginInFlight.current) return;
    const email = document.getElementById("emailInput").value;
    const password = document.getElementById("passwordInput").value;
    if (!email.trim() || !password) {
      setLoginError("Introduce tu email y contraseña para iniciar sesión.");
      return;
    }
    const rememberPassword = document.getElementById("passwordSave")?.checked;
    loginInFlight.current = true;
    setLoginPending(true);
    setLoginError("");
    try {
      const payload = { email, password };
      const response = await logIn(payload);
      const responseDecoded = response?.data && decodeToken(response.data.data);
      if (responseDecoded) {
        if (rememberPassword) saveLoginLS(payload, apiRest);
        else removeLoginLS(apiRest);
        dispatch(setUserLogged(true));
        dispatch(setUserData(responseDecoded));
        navigate(adminReturnPath(location.state?.from),{replace:true});
      } else {
        const alert = translateMessage(response?.message || "Bad request");
        setLoginError(alert?.message || "No se ha podido iniciar sesión. Vuelve a intentarlo.");
        dispatch(setAlert(alert));
      }
    } catch {
      setLoginError("No se ha podido iniciar sesión. Revisa la conexión y vuelve a intentarlo.");
    } finally {
      loginInFlight.current = false;
      setLoginPending(false);
    }
  };

  const handle2FA = async () => {
    const code = document.getElementById("2faInput").value;
    const response = await validateLogIn({
      code: code,
    });
    const responseDecoded = decodeToken(response.data);
    if (responseDecoded) {
      dispatch(
        setUserLogged({
          logged: true,
          token: responseDecoded,
          rol: "admin",
          email: responseDecoded.email,
          fullname: responseDecoded.fullname,
          superAdminId: responseDecoded.superAdminId,
        })
      );
      navigate(adminReturnPath(location.state?.from),{replace:true});
    } else {
      setLoginFailed(false);
    }
  };

  const renderLogin = () => {
    return (
      <form className="adminPanel" noValidate aria-busy={loginPending} onSubmit={(event) => {
        event.preventDefault();
        handleLogin();
      }}>
        <label className="labelLogin" htmlFor="emailInput">Email</label>
        <LoginInput id="emailInput" type="email" required autoComplete="username" placeholder="tu@email.com" disabled={loginPending}
          icon={<GoMail />} classname={loginFailed ? "w-100 errorValueInput" : "w-100"} />
        <label className="labelLogin" htmlFor="passwordInput">Contraseña</label>
        <LoginInput id="passwordInput" type="password" required autoComplete="current-password" placeholder="Tu contraseña" disabled={loginPending}
          classname={loginFailed ? "w-100 errorValueInput" : "w-100"} />
        {loginError && <div className="errorValue errorMessage" role="alert">{loginError}</div>}

        <div className="flex infoLoginPass mt-1" style={{ paddingTop: "10px" }}>
          <div className="w-100">
            <div className="flex-start" style={{ alignItems: "center" }}>
              <input
                id="passwordSave"
                disabled={loginPending}
                type="checkbox"
                className="loginRememberCheckbox"
                style={{ width: "24px", height: "24px" }}
              />{" "}
              <label htmlFor="passwordSave" style={{ paddingLeft: "10px" }}> Recordar contraseña</label>
            </div>
          </div>
          <button type="button" className="forgetPass" disabled={loginPending} onClick={() => !loginInFlight.current && callback()}>He olvidado mi contraseña</button>
        </div>

        <button type="submit" className="button-1 loginSubmit" disabled={loginPending}>
          {loginPending ? "Iniciando sesión…" : "Iniciar sesión"}
        </button>
      </form>
    );
  };

  const Login2FA = () => {
    return (
      <div className="w-100">
        <p className="labelLogin">Código de verificación</p>
        <Input
          id={"2faInput"}
          type={"text"}
          placeholder=""
          disabled={""}
          onKeyPress={() => null}
          icon={null}
          classname={loginFailed ? "errorValueInput w-100" : "w-100"}
        />
        {loginFailed ? (
          <div className="errorValue errorMessage">
            <RiErrorWarningFill /> {"El código es incorrecto"}
          </div>
        ) : (
          ""
        )}

        <div className="flex infoLoginPass mt-1">
          <div
            className="forgetPass w-100"
            role="button"
            tabIndex={0}
            onClick={() => setRequire2FA(false)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                setRequire2FA(false);
              }
            }}
            aria-pressed="false"
          >
            Volver a pedir el código
          </div>
        </div>

        <button className="button-1" onClick={handle2FA}>
          Acceder
        </button>
      </div>
    );
  };

  return (
    <div /*style={{ width: "400px" }}*/>
      {!require2FA ? renderLogin() : <Login2FA />}
    </div>
  );
};
